
























import { Component, Prop, Vue } from 'vue-property-decorator'
import { Card } from '@/types/Card'
import dealModule from '@/store/deal'
import { DealCardType } from '@/utils/enums'

@Component({
  name: 'CardItem'
})
export default class CardItem extends Vue {
  @Prop() readonly currentCard!: Card

  private async setCard(): Promise<void> {
    try {
      if (this.currentCard.type === DealCardType.SPECIFIC) {
        const currentDeal = this.currentCard.deals[0]
        if (!currentDeal) alert('Dieser Deal ist abgelaufen')
        await dealModule.setDeal(currentDeal)
        this.$router.push({
          name: 'DealDetail',
          params: { id: currentDeal._id }
        })
      } else if (this.currentCard.type === DealCardType.URL) {
        window.open(this.currentCard.url, '_blank')
      } else {
        this.$router.push({
          name: 'HomeDeals',
          params: { cardId: this.currentCard._id }
        })
      }
    } catch (err) {
      console.error('error settings card:', err)
    }
  }
}
